import { render } from "./Uitvaart.vue?vue&type=template&id=15435d98&scoped=true"
import script from "./Uitvaart.vue?vue&type=script&lang=js"
export * from "./Uitvaart.vue?vue&type=script&lang=js"

import "./Uitvaart.vue?vue&type=style&index=0&id=15435d98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15435d98"]])

export default __exports__